import React, { ReactElement } from "react";
import { useAppDispatch, useAppSelector } from "lib/redux/hooks";
import { menuEditorActions, menuEditorSelectors } from "../editorSlice";
import { WineMenuFormat } from "lib/api/pdfGenerator";
import { createDocumentHandler } from "../documentHandlerUtils";

export interface CoverPageProps {}

export function CoverPagePreview(props: CoverPageProps): ReactElement | null {
    const dispatch = useAppDispatch();
    const coverPageEditorOpen = useAppSelector(menuEditorSelectors.coverPageEditorActive);
    const document = useAppSelector(menuEditorSelectors.document);
    if (document == null || document.coverPage == null) {
        return null;
    }

    const toggleCoverPageEditor = () => dispatch(menuEditorActions.setCoverPageEditorActive(!coverPageEditorOpen));

    const docHandler = createDocumentHandler(document);
    const variant = parseInt(document.coverPage.variant || '1') as 1 | 2 | 3;
    const Renderer = docHandler.getCoverPageRenderer(variant);

    return (
        <div
            className={`bg-white flex flex-col relative overflow-hidden
                ${document.format === 'a5'      ? 'w-[152mm] h-[213.75mm]' :
                  document.format === 'a4-half' ? 'w-[109mm] h-[300.75mm]' :
                                                  'w-[214mm] h-[301mm]'}`}
            style={{pageBreakAfter: 'always'}}
            onClick={toggleCoverPageEditor}
        >
            <Renderer
                format={document.format as WineMenuFormat}
                imgUrl={document.coverPage.coverImageUrl}
                title={document.coverPage.title}
                logoImgUrl={document.coverPage.logoImageUrl}
            />
        </div>
    );
}
